module.exports = __webpack_public_path__ + "static/media/dleftArrow.43722d65.svg";